import Tabs from "components/BaseWidgets/tab";
import "./style.scss";
import {
  DeleteIcon,
  FilterIcon,
  NavNotification,
  ReferIcon,
  SettingsIcon,
  SettingsSecurity,
} from "assets/icons";
import AccountSettings from "./components/AccountSettings/index";
import SecurityAndPrivacy from "./components/SecurityAndPrivacy/index";
import Notification from "./components/Notification/index";
import Personalize from "./components/Personalize/index";
import DeleteAccount from "./components/DeleteAccount/index";
import SuccessStory from "./components/DeleteAccount/components/SuccessStory";
import { useState, useEffect } from "react";
import { useAccountSettings } from "hooks/api/useSettings";
import ReferAFriend from "components/ReferAFriend";
import { useLocation } from "react-router-dom";

function Settings() {
  const location = useLocation();
  const [isSuccessStory, setSuccessStory] = useState(false);
  const targetTab = String(location.state?.activeTab || "1");
  const [activeTab, setActiveTab] = useState(targetTab);
  const { data: accountData, isLoading: accLoading } = useAccountSettings();

  useEffect(() => {
    setActiveTab(targetTab);
  }, [targetTab]);

  const handleScroll = (key) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setActiveTab(key);
  };

  const tabItems = [
    {
      key: "1",
      label: (
        <span className="flex items-center gap-1-5">
          <SettingsIcon />
          Account settings
        </span>
      ),
      children: <AccountSettings data={accountData} isLoading={accLoading} />,
    },
    {
      key: "2",
      label: (
        <span className="flex items-center gap-1-5">
          <SettingsSecurity />
          Security & privacy
        </span>
      ),
      children: <SecurityAndPrivacy data={accountData} />,
    },
    {
      key: "3",
      label: (
        <span className="flex items-center gap-1-5">
          <NavNotification />
          Notifications
        </span>
      ),
      children: <Notification data={accountData} isLoading={accLoading} />,
    },
    {
      key: "4",
      label: (
        <span className="flex items-center gap-1-5">
          <FilterIcon />
          Personalize
        </span>
      ),
      children: <Personalize data={accountData} isLoading={accLoading} />,
    },
    {
      key: "5",
      label: (
        <span className="flex items-center gap-1-5">
          <ReferIcon />
          Refer & Reward
        </span>
      ),
      children: <ReferAFriend />,
    },
    {
      key: "6",
      label: (
        <span className="flex items-center gap-1-5 delete-container">
          <DeleteIcon />
          Delete account
        </span>
      ),
      children: <DeleteAccount setOpen={setSuccessStory} />,
    },
  ];

  return (
    <div className="container settings-container">
      {isSuccessStory ? (
        <SuccessStory setOpen={setSuccessStory} />
      ) : (
        <Tabs
          activeKey={activeTab}
          onChange={(key) => handleScroll(key)}
          className="settings-tab"
          variant="primary"
          position="left"
          items={tabItems}
        />
      )}
    </div>
  );
}

export default Settings;
